import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useIdleTimer } from 'react-idle-timer';

const INACTIVITY_TIMEOUT = 1000 * 60 * 60; // 1h

export const useLogoutWhenIdle = (
  isLoggedIn: boolean | null,
  logout: () => void
) => {
  const { t } = useTranslation();
  const [wasAutoLoggedOut, setWasAutoLoggedOut] = useState(false);

  const onIdle = () => {
    if (isLoggedIn) {
      logout();
      setWasAutoLoggedOut(true);
    }
  };

  const onActive = () => {
    if (wasAutoLoggedOut) {
      alert(t('hr2.error.idleTimeout'));
      setWasAutoLoggedOut(false);
    }
  };

  useIdleTimer({ onIdle, onActive, timeout: INACTIVITY_TIMEOUT });
};
